import { makeStyles, Switch, Typography } from '@material-ui/core'
import React from 'react'

const useStyles = makeStyles((theme) => ({
	root2: {
		width: 45,
		height: 26,
		padding: 0,
		margin: theme.spacing(1)
	},
	switchBase: {
		padding: 1,
		'&$checked': {
			transform: 'translateX(16px)',
			color: theme.palette.common.white,
			'& + $track': {
				backgroundColor: '#52d869',
				opacity: 1,
				border: 'none'
			}
		},
		'&$focusVisible $thumb': {
			color: '#52d869',
			border: '6px solid #fff'
		}
	},
	thumb: {
		width: 24,
		height: 24
	},
	track: {
		borderRadius: 26 / 2,
		border: `1px solid ${theme.palette.grey[400]}`,
		backgroundColor: theme.palette.grey[50],
		opacity: 1,
		transition: theme.transitions.create(['background-color', 'border'])
	}
}))

export const TextAndSwitch = ({ text = '', active = false, setActive = () => {} }) => {
	const classes = useStyles()

	return (
		<div
			style={{
				flexDirection: 'row',
				justifyContent: 'flex-start',
				alignItems: 'center',
				paddingBottom: 24,
				width: '100%'
			}}>
			<div
				style={{
					padding: 16,
					borderRadius: 6,
					display: 'flex',
					backgroundColor: '#F9F9F9',
					flexDirection: 'row',
					justifyContent: 'space-between',
					alignItems: 'center',
					width: '50%'
				}}>
				<Typography variant="body2">{text}</Typography>
				<Switch
					disableRipple
					checked={active}
					onChange={() => setActive(!active)}
					classes={{
						root: classes.root2,
						switchBase: classes.switchBase,
						thumb: classes.thumb,
						track: classes.track,
						checked: classes.checked
					}}
				/>
			</div>
		</div>
	)
}
